
      import API from "!../../../../modules/ubercabinet/views/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../modules/ubercabinet/views/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../../modules/ubercabinet/views/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../../modules/ubercabinet/views/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../modules/ubercabinet/views/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../../modules/ubercabinet/views/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../../modules/ubercabinet/views/node_modules/css-loader/dist/cjs.js!./edge.css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;
options.insert = insertFn.bind(null, "head");
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../modules/ubercabinet/views/node_modules/css-loader/dist/cjs.js!./edge.css";
       export default content && content.locals ? content.locals : undefined;
